import React, { useState } from 'react';
import { COLORS } from '@bumble/app/theme';
import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import SplitPane, { Pane, SashContent } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';

const SplitPaneContainer = styled(Box)<BoxProps>(({ theme }) => ({
  // height: 'calc(100vh - 124px)',
  height: '900px',
  minHeight: '900px',
  '& .react-split__pane': {
    overflow: 'scroll',
  },
  '& .split-sash-content': {
    display: 'block',
    width: '100%',
    height: '8px',
    backgroundColor: COLORS.PRIMARY,
    opacity: ' 0.3',
    transition: 'all 0.2s',
    borderRadius: '8px',
  },
  '& .split-sash-content.split-sash-content-vscode.split-sash-content-active': {
    backgroundColor: COLORS.PRIMARY,
    opacity: 1,
  },
}));

interface SplitPanesProps {
  top: React.ReactNode;
  bottom: React.ReactNode;
}

function SplitPanes({ top, bottom }: SplitPanesProps) {
  const [sizes, setSizes] = useState<(number | string)[]>(['50%', '50%']);

  return (
    <SplitPaneContainer>
      <SplitPane
        split="horizontal"
        sizes={sizes}
        onChange={setSizes}
        resizerSize={9}
        sashRender={(_index, active) => (
          <SashContent className={`sash-wrap-line ${active ? 'active' : 'inactive'}`}>
            {/* <span className="line" /> */}
          </SashContent>
        )}
      >
        <Pane style={{ paddingBottom: '20px' }}>{top}</Pane>
        <Pane style={{ paddingTop: '20px' }}>{bottom}</Pane>
      </SplitPane>
    </SplitPaneContainer>
  );
}

export default SplitPanes;
